export default __webpack_public_path__ + "static/media/image.extrogene-software.44f51f06.png";